import { render, staticRenderFns } from "./weekly-view-weekly-quantities-template.vue?vue&type=template&id=58cca11f"
import script from "./weekly-view-weekly-quantities-template.vue?vue&type=script&lang=js"
export * from "./weekly-view-weekly-quantities-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports